<template>
  <header class="settings-header">
        <h1 class="page-title font_regular font_600 text_20">
            <!-- <woot-sidemenu-icon></woot-sidemenu-icon> -->
            <slot></slot>
            <span>{{ headerTitle }}</span>
        </h1>
    </header>
</template>

<script>
export default {
    props: {
        headerTitle: {
            type: String,
            default: '',
        },
    },
}
</script>

<style>

</style>